/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Draggable from 'vuedraggable';
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';

const __vue_script__ = {
    name: 'AnyExternalPicker',

    components: { BaseSelect, Draggable, GenericDocExternalPicker },

    extends: BaseControl,

    props: {
        eventId: {
            type: String,
            required: true
        },

        value: {
            type: [Object, Array],
            default: () => ({})
        },

        options: {
            type: Object,
            default: () => ({})
        },

        allowedTypes: {
            type: Array,
            default: () => []
        },

        allowEmpty: {
            type: Boolean,
            default: false
        },

        multiple: {
            type: Boolean,
            default: false
        },

        edit: {
            type: Boolean,
            default: false
        },

        fpType: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            values: [],
            typeList: [],
            types: null,
        };
    },

    watch: {
        value: {
            deep: true,
            async handler() {
                this.setValues();
            },
        }
    },

    async created() {
        await this.init();
        this.setValues();
    },

    methods: {
        async init() {
            try {
                const metadata = await this.$services.metadata.getMetadata(this.eventId);
                this.types = this.$utils.metadata.getMetadataTypeList(metadata, { hideForPicker: true });

                let typeList = [];
                if (this.allowedTypes.length) {
                    typeList = this.types.filter(type => this.allowedTypes.includes(type.id));
                } else {
                    typeList = this.types;
                }

                this.typeList = typeList.sort((a, b) => a.label.localeCompare(b.label));
            } catch (error) {
                console.error('[AnyExternalPicker] Could not initialize the component:', error);
            }
        },

        setValues() {
            let values;

            if (this.multiple && Array.isArray(this.value)) {
                values = this.value.map(val => ({
                    selectedType: this.typeList.find(type => type.id === val.fp_type),
                    fp_ext_id: val.fp_ext_id
                }));
            } else {
                values = [{
                    selectedType: this.typeList.find(type => type.id === this.value?.fp_type),
                    fp_ext_id: this.value?.fp_ext_id
                }];
            }

            this.values = values;
        },

        onTypeSelect(value) {
            if (this.multiple) {
                const val = this.values.find(val => val.fp_ext_id === value.fp_ext_id && val.selectedType._id === value.selectedType._id);
                if (val) {
                    val.fp_ext_id = null;
                }
            } else {
                this.values[0].fp_ext_id = null;
            }
            this.onInput();
        },

        onInput() {
            const values = this.values.map(val => ({
                fp_type: val.selectedType?.id,
                fp_ext_id: val.fp_ext_id
            }));

            if (this.multiple) {
                this.$emit('input', values);
            } else {
                this.$emit('input', values[0]);
            }
        },

        addExternal() {
            this.values.push({
                selectedType: null,
                fp_ext_id: null
            });
        },

        removeExternal(value) {
            this.values = this.values.filter(val => val.fp_ext_id !== value.fp_ext_id);
            this.onInput();
        },

        clean() {
            this.$emit('input', null);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{staticClass:"any-external-picker",class:{ multiple: _vm.multiple },attrs:{"label":_vm.label,"tip":_vm.tip,"hint":_vm.hint,"uid":_vm.uid,"errors":_vm.errors,"warning":_vm.warning,"hint-after-label":_vm.hintAfterLabel,"dependant":_vm.dependant}},[_c('draggable',{staticClass:"externals-list",attrs:{"handle":".drag-handle"},on:{"change":_vm.onInput},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}},_vm._l((_vm.values),function(value,index){return _c('div',{key:(index + "-" + (value.fp_ext_id)),staticClass:"external"},[(_vm.edit && _vm.multiple)?_c('div',{staticClass:"drag-handle"},[_c('i',{staticClass:"icon-reorder"})]):_vm._e(),_c('div',{staticClass:"form-groups"},[_c('base-select',{ref:"selectedType",refInFor:true,staticClass:"type-selection",attrs:{"name":"selectedType","options-label":"label","options":_vm.typeList},on:{"input":function($event){return _vm.onTypeSelect(value)}},model:{value:(value.selectedType),callback:function ($$v) {_vm.$set(value, "selectedType", $$v)},expression:"value.selectedType"}}),(value.selectedType)?_c('generic-doc-external-picker',{attrs:{"name":"fpExtId","event-id":_vm.eventId,"allow-empty":_vm.allowEmpty,"placeholder":_vm.$t('general.forms.select_a_reference', [value.selectedType.label]),"fp-type":value.selectedType.id,"edit":_vm.edit},on:{"input":_vm.onInput,"clean":_vm.clean},model:{value:(value.fp_ext_id),callback:function ($$v) {_vm.$set(value, "fp_ext_id", $$v)},expression:"value.fp_ext_id"}}):_vm._e()],1),(_vm.edit && _vm.multiple)?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"btn btn-icon single",attrs:{"type":"button","aria-label":_vm.$t('general.remove')},on:{"click":function($event){return _vm.removeExternal(value)}}},[_c('i',{staticClass:"ic-x"})])]):_vm._e()])}),0),(_vm.edit && _vm.multiple)?_c('button',{staticClass:"btn btn-ctx-icon add-ext",attrs:{"type":"button","aria-label":_vm.$t('general.forms.add_new')},on:{"click":_vm.addExternal}},[_vm._v(_vm._s(_vm.$t('general.forms.add_new'))),_c('i',{staticClass:"icon-plus"})]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AnyExternalPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__